import React, { Component } from "react";
import { Paper, Divider } from "material-ui";

class VerticalListFields extends Component {
	render() {
		return (
			<Paper className={this.props.paperClass}>
				<div className="title-papercard">
					<h3>{this.props.titleText}</h3>
				</div>
				<Divider />
				<div className={this.props.contentClass}>{this.props.children}</div>
			</Paper>
		);
	}
}

export default VerticalListFields;



// WEBPACK FOOTER //
// ./src/components/VerticalListFields/VerticalListFields.js